export default `.ids-calendar {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  max-width: 100%;
}
.ids-calendar .calendar-legend-pane,
.ids-calendar .calendar-details-pane {
  display: none;
  width: 220px;
  height: auto;
}
.ids-calendar.show-legend .calendar-legend-pane, .ids-calendar.show-details .calendar-details-pane {
  display: block;
}
.ids-calendar .calendar-contents {
  flex-grow: 1;
}
.ids-calendar .calendar-toolbar-pane {
  display: flex;
  border-width: 1px 1px 0;
  border-style: solid;
  background-color: var(--ids-calendar-toolbar-color-background);
  border-color: var(--ids-calendar-toolbar-color-border);
  left: 0;
  top: 0;
  z-index: 4;
  flex-shrink: 0;
}
.ids-calendar .calendar-toolbar-pane .btn-picker ids-icon {
  position: relative;
  inset-inline-start: 6px;
  top: 1px;
}
.ids-calendar .calendar-custom-legend {
  display: none;
  border-width: 0 1px 1px;
  background-color: var(--ids-calendar-toolbar-color-background);
  border-style: solid;
  border-color: var(--ids-calendar-toolbar-color-border);
  box-sizing: border-box;
  padding: 4px;
}
.ids-calendar .calendar-custom-legend.is-populated {
  display: block;
}
.ids-calendar ids-toolbar-section::part(container),
.ids-calendar .ids-toolbar-section {
  align-items: center;
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=blue]::part(header) {
  background-color: var(--ids-color-accent-blue-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=orange]::part(header) {
  background-color: var(--ids-color-accent-orange-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=purple]::part(header) {
  background-color: var(--ids-color-accent-purple-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=green]::part(header) {
  background-color: var(--ids-color-accent-green-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=red]::part(header) {
  background-color: var(--ids-color-accent-red-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=teal]::part(header) {
  background-color: var(--ids-color-accent-teal-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header[color=neutral]::part(header) {
  background-color: var(--ids-color-accent-neutral-strong);
}
.ids-calendar .calendar-details-pane ids-accordion-header::part(header) {
  color: var(--ids-color-foreground-light-default);
}
.ids-calendar .calendar-details-pane ids-accordion-header ids-text::part(text) {
  overflow: hidden;
  width: 150px;
  white-space: nowrap;
}
.ids-calendar .calendar-details-pane .panel-content {
  padding-top: 15px;
  padding-bottom: 15px;
}
.ids-calendar .calendar-details-pane .panel-content hr {
  border-bottom: none;
  margin: 20px 0;
}
.ids-calendar ids-accordion-panel::part(content) {
  padding: 4px 0;
}
.ids-calendar .btn-previous,
.ids-calendar .btn-next {
  height: 36px;
}
.ids-calendar .btn-today-text {
  color: var(--ids-color-accent-blue-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=blue] {
  border-inline-start-color: var(--ids-color-accent-blue-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=orange] {
  border-inline-start-color: var(--ids-color-accent-orange-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=purple] {
  border-inline-start-color: var(--ids-color-accent-purple-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=green] {
  border-inline-start-color: var(--ids-color-accent-green-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=red] {
  border-inline-start-color: var(--ids-color-accent-red-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=teal] {
  border-inline-start-color: var(--ids-color-accent-teal-strong);
}
.ids-calendar .calendar-events-list .detail-item[color=neutral] {
  border-inline-start-color: var(--ids-color-accent-neutral-strong);
}
.ids-calendar .calendar-events-list {
  margin-top: 20px;
  padding: 0;
}
.ids-calendar .calendar-events-list .detail-item {
  background-color: var(--ids-calendar-toolbar-color-background);
  border-style: solid;
  border-color: var(--ids-calendar-toolbar-color-border);
  border-width: var(--ids-border-width-sm);
  border-inline-start-width: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  list-style: none;
  align-items: center;
  padding: 15px;
}
.ids-calendar .calendar-events-list .detail-item:focus {
  border-color: var(--ids-color-primary);
  outline: none;
}
.ids-calendar .calendar-events-list .calendar-detail-content {
  flex-grow: 1;
}
.ids-calendar .calendar-events-list .detail-item-duration {
  padding: 0 8px;
}
.ids-calendar .event-type-label,
.ids-calendar .event-types-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.ids-calendar .event-types-legend .event-type-color[color=blue] {
  background-color: var(--ids-color-accent-blue-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=orange] {
  background-color: var(--ids-color-accent-orange-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=purple] {
  background-color: var(--ids-color-accent-purple-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=green] {
  background-color: var(--ids-color-accent-green-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=red] {
  background-color: var(--ids-color-accent-red-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=teal] {
  background-color: var(--ids-color-accent-teal-strong);
}
.ids-calendar .event-types-legend .event-type-color[color=neutral] {
  background-color: var(--ids-color-accent-neutral-strong);
}
.ids-calendar .event-types-legend {
  display: none;
  padding: 10px;
}
.ids-calendar .event-type-label {
  margin: 0 8px;
}
.ids-calendar .event-type-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 10px;
  margin: 0 3px;
}
.ids-calendar .inline-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.ids-calendar #event-form-popup {
  width: 320px;
}
.ids-calendar #event-form-popup::part(arrow-bottom) {
  display: none;
}
.ids-calendar #event-form-popup::part(popup) {
  padding-top: 0;
  padding-bottom: 0;
}
.ids-calendar #event-form-header {
  align-items: center;
  color: var(--ids-color-neutral-10);
  height: 40px;
  padding-inline-start: 16px;
  padding-inline-end: 8px;
}
.ids-calendar #event-form-header ids-icon[data-action=close] {
  color: var(--ids-color-neutral-10);
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
}
.ids-calendar #event-form-header ids-icon[data-action=close]:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.ids-calendar #event-form #event-form-header[color=blue] {
  background-color: var(--ids-color-accent-blue-strong);
}
.ids-calendar #event-form #event-form-header[color=orange] {
  background-color: var(--ids-color-accent-orange-strong);
}
.ids-calendar #event-form #event-form-header[color=purple] {
  background-color: var(--ids-color-accent-purple-strong);
}
.ids-calendar #event-form #event-form-header[color=green] {
  background-color: var(--ids-color-accent-green-strong);
}
.ids-calendar #event-form #event-form-header[color=red] {
  background-color: var(--ids-color-accent-red-strong);
}
.ids-calendar #event-form #event-form-header[color=teal] {
  background-color: var(--ids-color-accent-teal-strong);
}
.ids-calendar #event-form #event-form-header[color=neutral] {
  background-color: var(--ids-color-accent-neutral-strong);
}
.ids-calendar #event-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.ids-calendar #event-form ids-list-box-option {
  text-align: left;
}
.ids-calendar #event-form ids-date-picker,
.ids-calendar #event-form ids-time-picker {
  max-width: 128px;
}
.ids-calendar #event-form-content {
  flex-grow: 1;
  box-sizing: border-box;
  padding: 12px 20px;
  position: relative;
}
.ids-calendar #event-form-actions ids-button {
  flex-grow: 1;
  border: 1px solid var(--ids-color-neutral-40);
  border-bottom-width: 0;
}
.ids-calendar #event-form-actions ids-button::part(button) {
  border-radius: 0;
  padding-top: 13px;
  padding-bottom: 13px;
}
.ids-calendar #event-form-actions ids-button[data-action=close] {
  border-inline-start-width: 0;
}
.ids-calendar #event-form-actions ids-button[data-action=submit] {
  border-inline-end-width: 0;
  margin-inline-start: -1px;
}
.ids-calendar #event-form-actions ids-button[data-action=submit]::part(button) {
  color: var(--ids-color-blue-70);
}
.ids-calendar #event-form-actions ids-button[data-action=submit]::part(button):hover {
  color: var(--ids-color-blue-80);
}

@media (max-width: 927px) {
  .ids-calendar.show-legend {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: 100%;
  }
  .ids-calendar.show-legend .calendar-legend-pane {
    display: none;
  }
  .calendar-view-pane,
  .ids-calendar.show-details .calendar-details-pane {
    width: 100%;
    min-width: 500px;
  }
  #event-form-popup {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  #event-form-popup::part(popup) {
    height: 100%;
    width: 100%;
  }
  #event-form-content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 50px;
  }
  #event-form-content ids-date-picker,
  #event-form-content ids-time-picker {
    max-width: unset;
  }
  #event-form-content .inline-container {
    position: relative;
    display: block;
  }
  #event-form-actions {
    background-color: var(--ids-popup-menu-color-background-default);
    bottom: 0;
    width: 100%;
  }
}
@media (width <= 480px) {
  .ids-calendar #event-form-popup {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
